import { ChangeDetectionStrategy, Component, Input, OnChanges, OnInit } from '@angular/core';

import { IPlayerChapter } from './chapters/IPlayerChapter';
import { VBrickPlayerComponent } from 'vbrick-player-src/VbrickPlayer.Component';

import styles from './VgScrubBarPreview.module.less';

@Component({
	selector: 'vg-scrub-bar-preview',
	changeDetection: ChangeDetectionStrategy.OnPush,
	template: `
		<ng-container *ngIf="!chapter; else chapterPreview">
			<div
				[ngClass]="styles.thumbnail"
				[style.background-image]="backgroundUri"
				[style.background-size]="backgroundSize"
				[style.background-position]="backgroundPosition"
				[style.width]="width"
				[style.height]="height"
			></div>
			<div [ngClass]="styles.timeDisplay">
				{{ timeSecs * 1000 | vbPlayerTime }}
			</div>
		</ng-container>
		<ng-template #chapterPreview>
			<div
				[ngClass]="styles.thumbnail"
				[style.background-image]="backgroundUri"
				[style.background-size]="backgroundSize"
				[style.width]="width"
				[style.height]="height"
			></div>
			<div [ngClass]="styles.chapterTitleDisplay">
				{{ chapter.title }}
			</div>
			<div [ngClass]="styles.timeDisplay">
				{{ timeSecs * 1000 | vbPlayerTime }}
			</div>
		<ng-template>
	`,
	host: {
		'[class]': 'styles.root'
	},
    standalone: false
})
export class VgScrubBarPreviewComponent implements OnChanges {
	@Input() public timeSecs: number;
	@Input() public chapter: IPlayerChapter;

	public readonly styles = styles;

	public backgroundUri: string;
	public backgroundSize: string;
	public backgroundPosition: string;
	public width: string;
	public height: string;

	constructor(
		public vbrickPlayer: VBrickPlayerComponent
	) { }

	public ngOnChanges(): void {
		if (this.timeSecs) {
			this.updateBackgroundPosition();
		}

		if (this.chapter) {
			this.backgroundUri = `url(${this.chapter.url})`;
			this.backgroundSize = `${this.vbrickPlayer.chapterHelper.chapterPreviewWidth}px ${this.vbrickPlayer.chapterHelper.chapterPreviewHeight}px`;
			this.width = `${this.vbrickPlayer.chapterHelper.chapterPreviewWidth}px`;
			this.height = `${this.vbrickPlayer.chapterHelper.chapterPreviewHeight}px`;
		} else {
			this.backgroundSize = `${this.vbrickPlayer.thumbnailCfg.pageResolution.width}px ${this.vbrickPlayer.thumbnailCfg.pageResolution.height}px`;
			this.backgroundUri = `url(${this.vbrickPlayer.thumbnailCfg.pageUrls[0]})`;
			this.width = `${this.vbrickPlayer.thumbnailCfg.tileResolution.width}px`;
			this.height = `${this.vbrickPlayer.thumbnailCfg.tileResolution.height}px`;
		}
	}

	public updateBackgroundPosition(): void {
		const frameNumber = Math.floor(this.timeSecs / (this.vbrickPlayer.thumbnailCfg.thumbnailDuration / 1000));
		const x = (frameNumber % this.vbrickPlayer.thumbnailCfg.thumbnailTiling.horizontal) * this.vbrickPlayer.thumbnailCfg.tileResolution.width;
		const y = Math.floor(frameNumber / this.vbrickPlayer.thumbnailCfg.thumbnailTiling.vertical) * this.vbrickPlayer.thumbnailCfg.tileResolution.height;
		this.backgroundPosition = `${-x}px ${-y}px`;
	}

}
